import React from "react";
import routes from "src/core/common/routes";
import Route from "src/core/common/components/modules/Route";
import InventoryTypeModal from "src/core/inventories/InventoryTypeModal";

export default function InventoriesPage({onRequestClose}) {
  return (
    <Route
      path={routes.inventoryType}
      Component={InventoryTypeModal}
      componentProps={{
        closeModal: onRequestClose,
      }}
    />
  );
}
